import "./Home.module.css";
import StickyHeader from "@/reusable_sections/Header";
import CuratedCollections from "./sections/CuratedCollections";
import HvorforNwConsult from "./sections/HvorforNwConsult";
import DustResistantSeals from "./sections/DustResistantSeals";
import ProductivityIncrease from "./sections/ProductivityIncrease";
import UnaprijediteSvojuTvrtku from "./sections/UnaprijediteSvojuTvrtku";
import StrategicAlliances from "./sections/StrategicAlliances";
import EcosDelPublico from "./sections/EcosDelPublico";
import OurExpertise from "./sections/OurExpertise";
import FeaturesBenefits from "./sections/FeaturesBenefits";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <StickyHeader />
      <CuratedCollections />
      <HvorforNwConsult />
      <DustResistantSeals />
      <ProductivityIncrease />
      <UnaprijediteSvojuTvrtku />
      <StrategicAlliances />
      <EcosDelPublico />
      <OurExpertise />
      <FeaturesBenefits />
      <Footer />
    </div>;
}